/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Slider from '@mui/material/Slider'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { positionChangeWidthSm, promptsArray, agesArray, gendersArray, pronounsArray, sexualitiesArray, interestedInArray, heightInchesArray, heightCMsArray, religionsArray, politicsArray, ethnicitiesArray, educationLevelsArray, childrenArray, familyPlansArray, alcoholArray, cigarettesArray, weedArray, drugsArray, petsArray, zodiacSignsArray, relationshipTypesArray, datingIntentionsArray, languagesArray, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../../helpers/textfields'
import { selectElement, selectMultiple } from '../../../../helpers/selects'
import { standardToggle } from '../../../../helpers/toggles'
import { cmToInches, inchesToCm, inchesToFeetString } from '../../../../helpers/globalHelpers'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { vitalInfoSetChanges } from '../../../../helpers/commonMethods'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX, ageSliderJSX, heightJSX, vitalInfoTextFieldJSX, vitalInfoSelectJSX, vitalInfoSelectMultipleJSX } from '../../../../helpers/commonJSX'

export const vitalInfoJSX = (
  fromTab,
  bioObject, setBioObject,
  newVitalInfo, setNewVitalInfo,
  loadingVitalInfo, setLoadingVitalInfo,
  saveSuccessful, setSaveSuccessful,
  bioErrors, setBioErrors,
  width,
  isDemo
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('newVitalInfo key length ->', Object.keys(newVitalInfo).length)
    // console.log('bioObject.vitalInfo key length ->', Object.keys(newVitalInfo).length)
    // console.log('key lengths equal ->', Object.keys(newVitalInfo).length === Object.keys(bioObject.vitalInfo).length)
    // console.log('all key values equal ->', Object.keys(bioObject.vitalInfo).filter(infoKey => (!(infoKey in newVitalInfo) || newVitalInfo[infoKey] !== bioObject.vitalInfo[infoKey])).length === 0)
    return !(
      Object.keys(newVitalInfo).length > 0
      && Object.keys(bioObject.vitalInfo).length > 0
      && Object.keys(newVitalInfo).length === Object.keys(bioObject.vitalInfo).length
      && Object.keys(bioObject.vitalInfo).filter(infoKey => (!(infoKey in newVitalInfo) || newVitalInfo[infoKey] !== bioObject.vitalInfo[infoKey])).length === 0
    )
  }

  const vitalInfoChangeHandler = (e, setErrors, setForm, form) => {
    e.preventDefault()
    // console.log('vitalInfoTextFieldChangeHandler runs')

    setBioErrors({ ...bioErrors, vitalInfo: false })
    setSaveSuccessful({ ...saveSuccessful, vitalInfo: false })

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)

    // console.log('value.length ->', value.length)
    // console.log('typeof value ->', typeof value)
    // console.log('value.charAt(0) ->', value.charAt(0))
    vitalInfoSetChanges(e, setErrors, setForm, form, name, value, newVitalInfo)
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')

    setBioErrors({ ...bioErrors, vitalInfo: false })
    setSaveSuccessful({ ...saveSuccessful, vitalInfo: false })

    setNewVitalInfo({ ...bioObject.vitalInfo })
  }

  const handleSavePressed = async () => {
    // console.log('handleSavePressed runs')
    const objectToUpload = {
      vitalInfo: { ...newVitalInfo },
    }

    // Upload Modifications
    if (isDemo) {
      setBioObject({ ...bioObject, vitalInfo: { ...bioObject.vitalInfo, ...objectToUpload.vitalInfo } })
      setSaveSuccessful({ ...saveSuccessful, vitalInfo: true })
    } else if (Object.keys(newVitalInfo).length > 0 
      && 
      !(
        Object.keys(newVitalInfo).length === Object.keys(bioObject.vitalInfo).length
        && Object.keys(bioObject.vitalInfo).filter(infoKey => (!(infoKey in newVitalInfo) || newVitalInfo[infoKey] !== bioObject.vitalInfo[infoKey])).length === 0
      )
    ) {
      console.log('attempting upload vitalInfo')
      setLoadingVitalInfo(true)
      setBioErrors({ ...bioErrors, vitalInfo: false })
      setSaveSuccessful({ ...saveSuccessful, vitalInfo: false })
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${bioObject._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        setBioObject({ ...bioObject, vitalInfo: { ...bioObject.vitalInfo, ...objectToUpload.vitalInfo } })

        setBioErrors({ ...bioErrors, vitalInfo: false })
        setSaveSuccessful({ ...saveSuccessful, vitalInfo: true })
        setLoadingVitalInfo(false)
        
      } catch (error) {
        console.log(error)
        setBioErrors({ ...bioErrors, vitalInfo: true })
        setSaveSuccessful({ ...saveSuccessful, vitalInfo: false })
        setLoadingVitalInfo(false)
      }
    }

  }

  return (
    <Box
      sx={{
        py: 3, my: fromTab === 'editProfile' ? 0 : 3,
        width: (fromTab === 'editProfile' && width < positionChangeWidthSm) ? '100%' : '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: (fromTab === 'editProfile' && width < positionChangeWidthSm) ? 0 : 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Vital Info', 
          '*Essential Profile Information',
          0
        )}

        {/* First Name — Textfield (max 30 characters) */}
        {vitalInfoTextFieldJSX('firstName', 'First Name', 30, 0, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Current City — Textfield (max 50 characters; placeholder: 'City, Country') */}
        {vitalInfoTextFieldJSX('currentCity', 'Current City', 50, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Hometown — Textfield (max 50 characters; placeholder: 'City, Country') */}
        {vitalInfoTextFieldJSX('hometown', 'Hometown', 50, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
        
        {/* University — Textfield (max 50 characters) */}
        {vitalInfoTextFieldJSX('university', 'University', 50, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Profession — Textfield (max 50 characters) */}
        {vitalInfoTextFieldJSX('profession', 'Profession', 50, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Employer — Textfield (max 50 characters) */}
        {vitalInfoTextFieldJSX('employer', 'Employer', 50, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Height — Select (48 — 90 in; 120 — 230cm) + Radio (in, cm) */}
        {heightJSX(newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
        {/* Age — Select (min 18, max 99) */}
        {/* {vitalInfoSelectJSX('age', 'Age', newVitalInfo.age === -1 ? ['Nothing selected', ...agesArray] : agesArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)} */}
        <Box
          sx={{ 
            mt: 2, mb: 1,
            width: '100%', 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {ageSliderJSX(
            'My Age', 
            <span style={{ color: newVitalInfo.age === -1 ? 'red' : 'blue' }}>{newVitalInfo.age === -1 ? 'No age selected' : newVitalInfo.age}</span>, 
            newVitalInfo.age, 
            'age',
            vitalInfoChangeHandler, 
            setBioErrors, 
            setNewVitalInfo, 
            newVitalInfo
          )}
        </Box>
  
  
        {/* Interested In Age Range — Two-way Slider (Min 18, Max 60+) */}
        {/* <Box
          sx={{ 
            mt: 1, mb: 2,
            width: '100%', 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {ageSliderJSX(
            'Interested-In Age Range', 
            <span style={{ color: 'blue' }}>{newVitalInfo.interestedInAgeMin} — {newVitalInfo.interestedInAgeMax}</span>, 
            [newVitalInfo.interestedInAgeMin, newVitalInfo.interestedInAgeMax], 
            'interestedInAge',
            vitalInfoChangeHandler, 
            setBioErrors, 
            setNewVitalInfo, 
            newVitalInfo
          )}
        </Box> */}
  
  
        {/* Gender — Select (Male, Female, Non-binary) */}
        {vitalInfoSelectJSX('gender', 'Gender', newVitalInfo.gender.length < 1 ? ['Nothing selected', ...gendersArray] : gendersArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Pronouns — Select up to 4 (she, her, hers, he, him, his, they, them, theirs, Not listed) */}
        {vitalInfoSelectJSX('pronouns', 'Pronouns', newVitalInfo.pronouns.length < 1 ? ['Nothing selected', ...pronounsArray] : pronounsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Sexuality — Select (Straight, Gay, Lesbian, Bisexual, Allosexual, Androsexual, Asexual, Autosexual, Demisexual, Fluid, Graysexual, Gynesexual, Monosexual, Omnisexual, Pansexual, Polysexual, Queer, Questioning, Skoliosexual, Spectrasexual, Not Listed) */}
        {vitalInfoSelectJSX('sexuality', 'Sexuality', newVitalInfo.sexuality.length < 1 ? ['Nothing selected', ...sexualitiesArray] : sexualitiesArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Interested In — Select (Men, Women, Non-binary People, Everyone) */}
        {vitalInfoSelectJSX('interestedIn', 'Interested In', newVitalInfo.interestedIn.length < 1 ? ['Nothing selected', ...interestedInArray] : interestedInArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Politics — Select */}
        {vitalInfoSelectJSX('politics', 'Politics', newVitalInfo.politics.length < 1 ? ['Nothing selected', ...politicsArray] : politicsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Ethnicity — Select */}
        {vitalInfoSelectJSX('ethnicity', 'Ethnicity', newVitalInfo.ethnicity.length < 1 ? ['Nothing selected', ...ethnicitiesArray] : ethnicitiesArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Education Level — Select */}
        {vitalInfoSelectJSX('educationLevel', 'Education Level', newVitalInfo.educationLevel.length < 1 ? ['Nothing selected', ...educationLevelsArray] : educationLevelsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Children — Select */}
        {vitalInfoSelectJSX('children', 'Children', newVitalInfo.children.length < 1 ? ['Nothing selected', ...childrenArray] : childrenArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Family Plans — Select */}
        {vitalInfoSelectJSX('familyPlans', 'Family Plans', newVitalInfo.familyPlans.length < 1 ? ['Nothing selected', ...familyPlansArray] : familyPlansArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Alcohol — Select */}
        {vitalInfoSelectJSX('alcohol', 'Alcohol', newVitalInfo.alcohol.length < 1 ? ['Nothing selected', ...alcoholArray] : alcoholArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Cigarettes — Select */}
        {vitalInfoSelectJSX('cigarettes', 'Cigarettes', newVitalInfo.cigarettes.length < 1 ? ['Nothing selected', ...cigarettesArray] : cigarettesArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Weed — Select */}
        {vitalInfoSelectJSX('weed', 'Weed', newVitalInfo.weed.length < 1 ? ['Nothing selected', ...weedArray] : weedArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Drugs — Select */}
        {vitalInfoSelectJSX('drugs', 'Drugs', newVitalInfo.drugs.length < 1 ? ['Nothing selected', ...drugsArray] : drugsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Zodiac Sign — Select  */}
        {vitalInfoSelectJSX('zodiac', 'Zodiac Sign', newVitalInfo.zodiac.length < 1 ? ['Nothing selected', ...zodiacSignsArray] : zodiacSignsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Relationship Type — Select */}
        {vitalInfoSelectJSX('relationshipType', 'Relationship Type', newVitalInfo.relationshipType.length < 1 ? ['Nothing selected', ...relationshipTypesArray] : relationshipTypesArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Dating Intentions — Select */}
        {vitalInfoSelectJSX('datingIntentions', 'Dating Intentions', newVitalInfo.datingIntentions.length < 1 ? ['Nothing selected', ...datingIntentionsArray] : datingIntentionsArray, 1, 1, newVitalInfo, setNewVitalInfo, setBioErrors, vitalInfoChangeHandler)}
  
  
        {/* Languages — Multiple Select up to 6 */}
        {vitalInfoSelectMultipleJSX('languages', 'Languages (Up to 6)', false, newVitalInfo.languages, languagesArray, vitalInfoChangeHandler, newVitalInfo, setNewVitalInfo, setBioErrors, 1, 1)}
  
  
        {/* Religion — Select Multiple */}
        {vitalInfoSelectMultipleJSX('religion', 'Religion', false, newVitalInfo.religion, religionsArray, vitalInfoChangeHandler, newVitalInfo, setNewVitalInfo, setBioErrors, 1, 1)}
  
  
        {/* Pets — Select Multiple */}
        {vitalInfoSelectMultipleJSX('pets', 'Pets', false, newVitalInfo.pets, petsArray, vitalInfoChangeHandler, newVitalInfo, setNewVitalInfo, setBioErrors, 0, 1)}

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons() &&
          saveAndCancelButtonsJSX(
            loadingVitalInfo,
            !(showSaveAndCancelButtons() || loadingVitalInfo),
            handleCancelPressed,
            handleSavePressed,
            0,
            bioErrors.vitalInfo ? 0 : 2,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loadingVitalInfo &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {bioErrors.vitalInfo &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.vitalInfo &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}